import { Stack, Typography } from '@mui/material'
import type { ReactNode } from 'react'
import type { AggregateSummary } from './portfolioAggregates'
import { formatPropertyCoverage } from './portfolioAggregates'

export function renderHelpLines(lines: string[]): ReactNode {
  return (
    <Stack spacing={0.5}>
      {lines.map(line => (
        <Typography key={line} variant="caption">
          {line}
        </Typography>
      ))}
    </Stack>
  )
}

export function renderAggregateTooltip(
  summary: AggregateSummary,
  label: string,
  aggregationText: string,
  extraLines: string[] = [],
): ReactNode {
  return renderHelpLines([
    `${label}: ${aggregationText}.`,
    `Coverage: ${formatPropertyCoverage(summary.contributors, summary.total)}.`,
    ...extraLines,
  ])
}
